var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalileaIcono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.913 35.6429C28.2567 44.0826 14.5045 44.0621 6.86898 35.6225C3.3529 31.7509 -2.41014 37.4456 1.08513 41.3172C11.5293 52.8909 31.2111 52.8909 41.6761 41.3376C45.1713 37.4661 39.4083 31.7714 35.913 35.6429Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.599 10.5701C34.3104 6.5142 30.4615 3.95364 26.1964 2.86796C16.3347 0.327881 4.2053 5.77676 3.97644 19.1736C4.37174 41.7066 38.4298 41.7271 38.8251 19.1736C38.7627 15.7937 37.9513 12.9259 36.599 10.5701Z",
    fill: "#7E02FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6693 10.611C33.6453 10.611 36.0579 8.23563 36.0579 5.30549C36.0579 2.37535 33.6453 0 30.6693 0C27.6933 0 25.2808 2.37535 25.2808 5.30549C25.2808 8.23563 27.6933 10.611 30.6693 10.611Z",
    fill: "#FC3E58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalileaIcono);
export default __webpack_public_path__ + "static/media/galilea-icono.887baec4b87cb1868be01581fa06fcc0.svg";
export { ForwardRef as ReactComponent };